import AES from 'crypto-js/aes'
import UTF8 from 'crypto-js/enc-utf8'
import SHA1 from 'crypto-js/sha1'

/**
 * SHA-1 해시 알고리즘
 **/
export function makeSHA1Key(key: string): string {
    return SHA1(key).toString()
}

/**
 * AES 알고리즘을 사용하여 데이터 암호화
 **/
export function encryptAes(value: string, key: string): string {
    return AES.encrypt(value, key).toString()
}

/**
 * AES 알고리즘을 사용하여 데이터 복호화
 **/
export function decryptAes(value: string, key: string): string {
    return AES.decrypt(value, key).toString(UTF8)
}
